// extracted by mini-css-extract-plugin
export default {"main":"Dashboard_main__5TM0R","date":"Dashboard_date__S6r3Z","title":"Dashboard_title__RUbrd","single":"Dashboard_single__eoLPn","description":"Dashboard_description__4zvQS"};